module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chap-title"
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/07_Contents#ch2",
      "id": "ch2"
    }
  }, [_vm._v("BACH (1685–1750)")])]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "margin-top": "-3.5em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/07_Contents#ch2_1",
      "id": "ch2_1"
    }
  }, [_vm._v("His Last Work")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "paranoindent1"
  }, [_c('em', [_vm._v("In 1982, Wolff transcribed Bach’s last choral-prelude for ’cello and piano as a gift for musician friends. He added a quotation on this work from Albert Schweitzer’s book")]), _vm._v(" J. S. Bach "), _c('em', [_vm._v("(chapter 12);"), _c('span', {
    attrs: {
      "href": "#/44_Notes#fn_5",
      "id": "rfn_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" Wolff’s comments follow. The final bars of the transcription have been combined with Wolff’s inscription by the editor ("), _c('a', {
    attrs: {
      "href": "#/#Ex2"
    }
  }, [_vm._v("Ex. 2")]), _vm._v(")")]), _vm._v(".")])]), _vm._v(" "), _c('h3', [_c('em', [_vm._v("[Albert Schweitzer]")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("It seems that Bach spent his last days totally in a darkened room. When he felt that death was near he dictated to Altnikol"), _c('span', {
    attrs: {
      "href": "#/44_Notes#fn_6",
      "id": "rfn_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" a choral Fantasy on the melody “Wenn wir in höchsten Nöthen sein” (when we are in ultimate crisis), but asked him to put as a title “Vor deinen Thron tret ich allhier” (here I step before Your throne), which is sung on the same tune. In the script one can still read all points of rest which the patient has to take. Day after day, the ink got more watery; the notes written in the half-dark behind darkened windows are hardly legible.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("In the dark room, already surrounded by the shadows of death, the master created this work which, even among his own compositions, is unique. The counterpoint revealed therein is of such perfect art that no description could do it justice. Each segment of the hymn is treated in a fugue in which each time the inversion acts as a counter-subject. Nevertheless the voices flow so naturally that after the second line one is no longer aware of the métier, but is under the spell of the spirit which speaks to us in these G major harmonies. The noises of the world did not longer penetrate through the curtains of these windows. The dying master was surrounded by harmonies of the sphere. For this reason no suffering is included in the music. The quiet eighth-notes move beyond all human passion; over the whole piece there is the word “transfiguration” in lights.")]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap",
    staticStyle: {
      "padding-top": "1.5em"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "id": "Ex2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('em', [_vm._v("[Ex. 2]")])])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/chap2_page8_fig1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  })]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('h3', [_c('em', [_vm._v("[Konrad Wolff]")])])]), _c('p', {
    staticClass: "paranoindent1"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("1982 is no longer as flowery as 1907 (the year of my birth and of the genesis of Schweitzer’s book), but I do feel very much along these lines, as far as the substance is concerned. The choral prelude is the ultimate condensation of his G major peace music—the Christmas oratorio; the two Preludes of the Well-Tempered Clavier books; the ")]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("Fifth French Suite and the Fifth Partita in their Sarabandes; the Cello Suite, etc., etc. It is also the only piece known to me in which chromaticism appears in the major mode in Bach. The long last note of the hymn, under which all other voices die away, one by one, gently and serenely, is the closest one can come to describe Eternity in music, I think. So you see this scribbler, vintage 1907, is a little flowery himself still in 1982.")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('h2', [_c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/07_Contents#ch2_2",
      "id": "ch2_2"
    }
  }, [_vm._v("[Spirit, Style, and Forms: A Brief Exposition]")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "paranoindent1"
  }, [_c('em', [_vm._v("Extracted from a rough draft, this lecture-recital was the first of four given at St. Cecilia’s House in London for the benefit of the Musicians’ Benevolent Fund, year unknown but estimated to be about 1950")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("His forms have often been compared to those of nature. There seems to be a natural order and coherence in the works which defy analysis, because the patterns are not totally regular nor calculable and include what G. K. Chesterton"), _c('span', {
    attrs: {
      "href": "#/44_Notes#fn_7",
      "id": "rfn_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("7")])]), _vm._v(" once called the “silent swerving from accuracy by an inch that is the uncanny element in everything.” Of the forty-eight fugues of the Well-Tempered Clavier, for instance, there is not a single one without some irregularity, which one recognizes as such by looking at the other forty-seven fugues. Or take the Brandenburg Concertos. He establishes the type, in these six works, as a concerto in three movements, but the first concerto has four movements, and the third concerto only two. One might say that the only rule of form which he observes without exception is that in every piece there must be an exceptional occurrence proving the rule....")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Bach is essentially a composer of "), _c('em', [_vm._v("series")]), _vm._v(" of pieces. He hardly ever composed single compositions. Like a portrait photographer who, in order to give a complete impression of his subject, takes a series of poses, Bach undertook each type of composition in a series of works—the six Brandenburg Concertos, the six violin solo pieces, the six French Suites, the twenty-four Preludes and Fugues of the first book of the Well-Tempered Clavier, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Bach’s forms have been very much misunderstood. Some people, for instance, speak of him as a “mathematician,” meaning that he is theoretical and schematic in the structure of his pieces. Nothing could be further from the truth. Although Bach, in his two-part dances and rondos, etc., uses exact proportions of length, he always "), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("avoids mechanical or schematic repetitions. Anything schematic was contrary to his nature. That is why he declared that he did not like to write variations....")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The other, more important misunderstanding arises from a false dramatization of his pieces in performance. Conductors, organists, pianists, etc., very often try to build the compositions up to a final climax, and the end of an organ fugue or an orchestral suite is not infrequently made to sound like the end of the Star Spangled Banner. This attitude, which is furthered by misleading nineteenth century editions of the music, destroys the line of the piece in nearly all cases. Actually the climax in a Bach toccata or fugue, or concerto, hardly ever comes at the end. It generally occurs toward the end of the middle section, and is built like nature builds waterfalls: the stream is condensed into the fall and then continues to flow freely downward. If you remember the cadenza from the first movement of the Fifth Brandenburg Concerto, you will know what I mean.")])]), _c('blockquote', [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("[Another example is from the "), _c('em', [_vm._v("Well-Tempered Clavier, Book I, Prelude in C minor")]), _vm._v(" (")]), _c('a', {
    attrs: {
      "href": "#/#Ex3"
    }
  }, [_vm._v("Ex. 3")]), _vm._v("). After repeating this bold pattern for 24 bars,")])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap",
    staticStyle: {
      "padding-top": "1.5em"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "id": "Ex3"
    }
  }, [_c('em', [_vm._v("[Ex. 3]")])]), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/chap2_page10_fig1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Bach leads to the climax, and concludes thus:]")]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap",
    staticStyle: {
      "padding-top": "1.5em"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/chap2_page10_fig2.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/chap2_page11_fig1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("The dramatization of forms is also contrary to the very spirit of Bach’s music. It does not end, like in movies or novels, with marriage and death, respectively. This music, as I said, is certainly not mathematical, abstract or dry ever; it always is human and warm, and runs the whole gamut of human emotions. Just consider his fugue themes from the Well-Tempered Clavier, as an example in a nutshell [")]), _c('a', {
    attrs: {
      "href": "#/#Ex4"
    }
  }, [_vm._v("Exs. 4")]), _vm._v("–"), _c('a', {
    attrs: {
      "href": "#/#Ex6"
    }
  }, [_vm._v("6")]), _vm._v("].")]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap",
    staticStyle: {
      "padding-top": "1.5em"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "id": "Ex4"
    }
  }, [_c('em', [_vm._v("[Ex. 4]")]), _c('br'), _c('b', [_vm._v("Book II, G minor—Stubborn [For 4 voices]")])]), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/chap2_page11_fig2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap",
    staticStyle: {
      "padding-top": "1.5em"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "id": "Ex5"
    }
  }, [_c('em', [_vm._v("[Ex. 5]")]), _c('br'), _c('b', [_vm._v("Book II, G Major—Playful")])]), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/chap2_page11_fig3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap",
    staticStyle: {
      "padding-top": "1.5em"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "id": "Ex6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('em', [_vm._v("[Ex. 6]")]), _c('br'), _c('b', [_vm._v("Book I, E minor—Furious")])]), _c('b', [_c('a', {
    attrs: {
      "href": "#/#fn_0",
      "id": "rfn_0"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/chap2_page12_fig1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("But it is never colossal or monumental, on the one hand, and never romantic in the sense of emotional, on the other hand. [In the margin, Wolff wrote: “Elaborate.”]")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("It would be interesting to have a confirmation of this in Bach’s own words. Unfortunately, he hardly ever expressed himself about his art, and we know very little. Almost the only authentic source of Bach’s conception of music consists in a little preface which he gave his pupils as the heading of a textbook on thorough bass."), _c('span', {
    attrs: {
      "href": "#/44_Notes#fn_8",
      "id": "rfn_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_vm._v("PRECEPTS AND PRINCIPLES FOR PLAYING THE THOROUGH-BASS OR ACCOMPANYING IN FOUR PARTS")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("by")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("The Royal Court Composer and"), _c('br'), _vm._v("Kapellmeister as well as"), _c('br'), _vm._v("Director of Music and Cantor of the Thomas-Schule"), _c('br'), _vm._v("JOHANN SEBASTIAN BACH"), _c('br'), _vm._v("at Leipzig"), _c('br'), _vm._v("for his Students in Music."), _c('br'), _vm._v("1738.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("This is what he says:")]), _vm._v(" "), _c('blockquote', {
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("The thorough-bass is the most perfect foundation of music, being played with both hands in such manner that the left hand plays the notes written down while the right adds consonances and dissonances, so that this results in a full-sounding harmony to the Honour of God and the permissible delectation of the spirit; the ultimate end and final goal, as of all music, so of the thorough-bass, should be none else but the Glory of God and the renewal of the soul. Where this is not observed, there will be no real music but only a devilish bawling and droning. (Teuflisches Geplerr und Geleyer)."), _c('span', {
    attrs: {
      "href": "#/44_Notes#fn_9",
      "id": "rfn_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("9")])])])]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("As you see, it is an essentially private conception of music, as something that passes directly between each individual and God, and it explains why Bach’s works, even the greatest creations like the B minor Mass and the St. Matthew Passion, when compared to the Messiah, for instance, lack the truly and intentionally monumental quality which makes masses integrate, the very quality which made Beethoven prefer Handel to Bach and Mozart. The work which I am going to play now, and which I selected because it belongs to Bach’s greatest keyboard works and has been unduly neglected in the concert repertoire, is also one in a series. The series here, however, consists of only two compositions: the other one is the Italian Concerto [")]), _c('a', {
    attrs: {
      "href": "#/#Ex7"
    }
  }, [_vm._v("Ex. 7")]), _vm._v("]. Bach published only very few of his works himself, and the fact that he published the B minor Overture ["), _c('a', {
    attrs: {
      "href": "#/#Ex8"
    }
  }, [_vm._v("Ex. 8")]), _vm._v("] together with the Italian concerto indicates how much he must have valued it. What is the reason for the strange, indeed unique, coupling of a concerto with a dance suite? It is that in both pieces Bach attempts to create the illusion of a full orchestra playing."), _c('span', {
    attrs: {
      "href": "#/44_Notes#fn_10",
      "id": "rfn_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("10")])]), _vm._v(" Just as the Italian concerto is meant to suggest a real concerto for piano and orchestra with marked solo and tutti sections, this Overture suggests pieces like the Suite for flute and strings in the same key. It has one thing in common with the flute suite, moreover, and that is that at the end, after the last dance, a light and brilliant final number is added, Badinerie-Echo.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Now that you have heard this music, I want to say just a few words about the French element in it. Bach had the same cosmopolitan attitude which had distinguished the medieval scholars who had taught in France, Italy, England, Flanders, etc., or the Renaissance painters who had traveled from one land to another, without feeling their art particularly associated with the land of their birth. Bach, though prevented from traveling through the unhappy general conditions of his country, thoroughly studied music of all nations, and his boundless imagination made it possible for him to become as French as Couperin in a piece like the one I played, and as Italian as Vivaldi in the Italian Concerto. As a man and as a Lutheran he was German, but as an instrumental composer he did not have—and did not want to have—any fixed nationality. No wonder, then, that his works, when at last they were rediscovered, made the round of the world. Characteristically, the greatest interpreter of Bach in our day is a Catalan musician [Pablo Casals]. Even the French impressionists, so anti-German in their attitude to music, excepted Bach. I believe that it is not an accidental constellation that today, when the long period of nationalism in music, first represented by masters like Mussorgsky, Verdi, Debussy and Bartók, and later by many lesser figures like Reger and Villa-Lobos, is finally on the way out, Bach is more and more heard and much better understood by the general public than 30 years ago.")]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap",
    staticStyle: {
      "padding-top": "1.5em"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "id": "Ex7"
    }
  }, [_c('em', [_vm._v("[Ex. 7]")]), _c('br'), _c('b', [_vm._v("Italian Concerto, BWV 971")])]), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/chap2_page13_fig1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap",
    staticStyle: {
      "padding-top": "1.5em"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "id": "Ex8"
    }
  }, [_c('em', [_vm._v("[Ex. 8]")]), _c('br'), _c('b', [_vm._v("Overture in B minor")])]), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/chap2_page13_fig2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v(" I would like to say a little more clearly what to me seems the essential of Bach’s music, as regards his background. By studying, transcribing, & imitating past and present masters of all nations he tried to overcome any national or historic limitations, and in his technic of composing always his pieces in complete series, he actually created his own background.... This distinguishes Bach from all later masters. It is true that Mozart once boasted that he was able to write in any style, and so he was, as is shown by a few small samples, but essentially he remained a child of his time and of the German-Austrian nation. And in this same way all later masters can be considered, by the musicologist, from the viewpoint of personal language and style, and given background. Bach alone makes his background transcend all limits. The self-sufficiency of his art, a world in itself, can only be compared with that of Homer. And as in the case of Homer, I am sure, if Bach’s works had come to us only indirectly, people would be apt to believe that a whole generation of composers, not a single one, went into these works. I talked to a Greek scholar last year who had devoted much study to the question of Homer and who told me that the existence of Bach’s oeuvre as the output of a single man was maybe the strongest argument in favor of the authorship of a single creator of the Iliad and Odyssey.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }), _c('p', {
    staticClass: "paraindent1"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("The completeness of this world made it impossible to copy it, and one understands how C.P.E. Bach tried to find new styles and forms. ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("The classical German masters then composed in these new styles and forms, and Bach’s influence remained indirect for almost 200 years. It is only today that some leading composers, like Stravinsky and Hindemith, have had the courage to compose in the old forms and styles, and they, too, take off from Bach’s predecessors rather than from Bach himself.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('p', {
    staticClass: "paraindent1"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("As a characteristic example of Bach’s indirect influence, I want to play for you now a short late Adagio by Mozart [")]), _c('a', {
    attrs: {
      "href": "#/#Ex9"
    }
  }, [_vm._v("Ex. 9")]), _vm._v("], Bach’s first and greatest indirect disciple. Mozart began to know the works of Bach only at the end of his life, and it is certain that this piece would not have been written the way it is without the knowledge of Bach’s music. The independence of voices, chromaticism of harmonies, the daring melody lines moving in dissonant intervals, all recall Bach. But no words are required to explain the essential difference in the form and style of the music, all the more evident in juxtaposition to the Bach Overture which I played before, because this piece also is in B minor and in generally a similar mood.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("If I had time I should have liked to go into a more technical analysis of the music of Bach as an end and a beginning. I should have wanted to demonstrate how he managed to provide the beautiful melodious and harmonious forest of Italian music with a million different trees of melodic lines and rhythmic subtleties such as he found in German and Flemish music, and how this became possible through the "), _c('u', [_vm._v("one entirely new")]), _vm._v(" musical feature that he created: the harmonic direction. For up to Bach, both Northern and Italian music generally move about in tonic and dominant and occasional modal or other more remote chords during a phrase until the phrase finally comes down in a cadence.... Bach was the first who looked to it, once and for all, that the harmonies should move logically and connectedly from one end of a phrase, or, indeed, often of a whole piece, to the other so that the final cadence had its roots in the first beginning. (First Prelude, Well-Tempered Clavier).")]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "caption",
    attrs: {
      "id": "Ex9"
    }
  }, [_c('em', [_vm._v("[Ex. 9]")]), _c('br'), _c('b', [_vm._v("Mozart (1756–1791): Adagio in B minor, KV 540 [composed in 1788]")])]), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/chap2_page15_fig1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("With this musical concept he succeeded in creating, out of all the many types of music which he found, respected and continued, something that was entirely new in the spirit, the first complete world of music including everything that went before, and by this very all-inclusiveness, elevate it to a new level, to the level of music as an absolute art, not any more for dance, or for song, or for church, or for drama, or for entertainment, but just music, whatever the purpose. He was not a revolutionary, for he destroyed nothing of what went before; he also did not create by way of evolution because he left those musical styles and forms which he used such as they were, but he fused them all and gave them a new life from within so that they became, outwardly identical, entirely new in the spirit. We might therefore say, using a fine old term of Roman law, that Bach, who historically speaking was the end of an epoch, became the beginning, not only of a new epoch but of all our music, by way of novation.")]), _c('span', {
    attrs: {
      "href": "#/44_Notes#fn_11",
      "id": "rfn_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("11")])])]), _vm._v(" "), _c('blockquote', {
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('p', {
    staticClass: "paranoindent1"
  }, [_c('em', [_vm._v("[In what appeared to be an intended insertion or correction, Wolff added these handwritten lines at the end of his mimeographed paper. Although there is some redundancy, this particular wording seemed too interesting to neglect.]")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The work of Bach—work the existence of which seems to have been prepared for by centuries of arduous labor, and in which the fertility of many lands is consummated—realizes the synthesis of two fundamental expressions of polyphony with unparalleled felicity. That is the secret of the impression of absolute perfection which we receive from the music of Bach.")]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent",
    staticStyle: {
      "font-size": "0.9em",
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "fn_0"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#rfn_0"
    }
  }, [_vm._v("*")]), _vm._v(" This has been called “the ill-tempered fugue of the Well-Tempered Clavier.” [Wolff]")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d95e144","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/15_Chapter2.vue
// module id = 102
// module chunks = 0